<template lang="pug">
    div.inline-error-control(v-if='errorMessage' :class='elClass') {{ errorMessage }}
</template>

<script>
export default {
    name: 'inline-error-control',
    props: {
        errors: {
            default: null,
            type: [String, Array],
        },
        relative: {
            type: Boolean,
        },
    },
    computed: {
        errorMessage() {
            if (!this.errors) {
                return ''
            }

            const e = Array.isArray(this.errors) ? this.errors : [this.errors]

            return e.join(' ')
        },
        elClass() {
            return {
                'inline-error-control--relative': this.relative,
            }
        },
    },
}
</script>
